<template>
  <div id="app" class="ny-default">
    <navView :count="count"/>
    <router-view @childVal="parentVal"></router-view>
    <footerView />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
     count:0
    }
  },
  created() {},
  computed: {},
  methods: {
    parentVal(val){
      this.count=val;
    }
  },
  mounted() {},
  destroy() {},
};
</script>
<style lang="less">
.ny-default {
  width: 100%;
  min-width: 1240px;
  max-width: 1920px;
  margin: 0 auto;
}
</style>
